import { Component, AfterViewInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FileSelectDirective, FileDropDirective, FileUploader, FileItem } from 'ng2-file-upload';
import { DataService } from '../shared/data.service';

@Component({
    selector: 'image-uploads',
    template: require('./partials/image-upload.component.html'),
    styles: [ '.upload-tool {height: 20px; margin-top: -5px}',
              '.progress-cover {margin-right: 5px; float: left}', 
              '.uploader {margin: 15px 10px 0px 0px}',
              '.clickLink {cursor: pointer}']
})
export class ImageUploadComponent implements AfterViewInit {

    public uploaders:FileUploader[] = [];
    public tempData: Object = {}; // indexed by itemAlias for image display

    public defaultImage: string = 'default.png';
    @Input('reactiveForm') form: FormGroup;
    @Input() groupName: string;
    @Input() imagePath: string;
    @Input() addApi: string;
    @Input() deleteApi: string;
    @Input() deleteDir: string;
    @Input() images: Object;
    @Input() thumbSize: number;

    constructor(private dataService: DataService) {}

    ngAfterViewInit() {
        // Uploaders
        Object.keys((<FormGroup>this.form.get(this.groupName)).controls).forEach(alias => {
            this.uploaders.push(new FileUploader({itemAlias: alias, url: this.addApi, queueLimit: 1}));
        });
        // Callbacks
        for(let uploader of this.uploaders){
            uploader.onSuccessItem = ((item: FileItem, response: any, status: any, headers: any) => {
                // response contains the uploaded file name
                this.form.get([this.groupName, item.alias]).patchValue(response);
            });
            uploader.onErrorItem = ((item: FileItem, response: any, status: any, headers: any) => {
                console.error("[Upload]", response, status);
            });
            uploader.onCompleteItem = ((item: FileItem, response: any, status: any, headers: any) => {
                console.log("[Upload]", response, status);// the url will be in the response
            });
        }
    }

    onRemoveImage(item: FileItem){
        if(this.form.get([this.groupName, item.alias]).value) { // means it has been uploaded
            // delete from server
            this.dataService.delete(this.deleteDir,item._file.name);
            this.form.get([this.groupName, item.alias]).patchValue(null); 
        }
        item.remove();
    }

    onChangeImageHandler(imgId: string, event: any) {
        if (event.target.files && event.target.files[0]) {
            var reader = new FileReader();
            reader.onload = (event) => {
                this.tempData[imgId] = event.target['result'];
            }
            reader.readAsDataURL(event.target.files[0]);
        }
    }

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/image-upload.component.ts